import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Failed to load component: ', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null
    }

    return this.props.children;
  }
}
